module.exports = __webpack_public_path__ + "img/hp-h4.52575ac6.svg";